const style = {
  container: {
    background: `#f6f6f6`
    // position: `absolute`,
    // zIndex: 999,
  },
  box: {
    display: `block`,
    // background: `white`,
    minHeight: `100px`,
    padding: `25px 25px`
  },
  item: {
    fontSize: `13px`,
    cursor: `pointer`
  },
  checkbox: {
    display: `block`,
    height: `9px`,
    width: `9px`,
    border: `1px solid #A94545`,
    background: `white`
  },
  checkbox_tick: {
    display: `block`,
    height: `9px`,
    width: `9px`,
    border: `1px solid #A94545`,
    background: `#A94545`
  },
  dateRow: {
    // paddingTop: `5px`,
    // paddingBottom: `5px`
  },
  date: {
    display: `block`,
    fontSize: `14px`,
    textAlign: `center`
  },
  dateChange: {
    fontSize: `16px`,
    fontWeight: 800
  },
  dateIncreate: {
    color: `green`
  },
  dateDecrease: {
    color: `red`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Support/style/filterbox.js